module.exports = __webpack_public_path__ + "img/FR12280.c5d03610.svg";